export default __webpack_public_path__ + "assets/unselected-checkbox.7eda8f82.webp";